import React from 'react';
import RocketsList from '../Components/RocketsList';

const RocketsPage = () => (
  <div>
    <RocketsList />
  </div>
);

export default RocketsPage;
